import Vue from "vue";
import moment from "moment";

Vue.filter("formatDateTime", value => {
  if (value) {
    return moment(String(value)).format("DD MMMM YYYY, HH:mm");
  }
});

Vue.filter("formatDate", value => {
  if (value) {
    return moment(String(value)).format("DD MMMM YYYY");
  }
});

Vue.filter("formatDateShort", value => {
  if (value) {
    return moment(String(value)).format("DD MMM");
  }
});
Vue.filter("fromNow", value => {
  if (value) {
    return moment(String(value)).fromNow();
  }
});

Vue.filter("getDayFromDate", value => {
  if (value) {
    return moment(String(value)).format("dddd");
  }
});
